function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#60daa8",
  d: "M512 256c0 141.39-114.61 256-256 256S0 397.39 0 256 114.61 0 256 0s256 114.61 256 256z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00ce8e",
  d: "M237.54 428.99c21.125-20.02 30.492-47.676 30.492-47.676l-34.047-28.906s-41.836-80.371-41.578-80.168C99.001 163.62 169.516 16.35 170.313 14.69 71.079 49.94.003 144.67.003 256c0 131.76 99.566 240.28 227.55 254.44-16.676-25.258-12.875-59.777 9.984-81.445z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fffcdc",
  d: "M240.35 393.61a37.148 37.148 0 01-22.754-7.766l-120.68-93.09c-16.305-12.574-19.328-35.988-6.75-52.293 12.574-16.3 35.988-19.324 52.293-6.75l93.367 72.027 128.82-142.57c13.805-15.277 37.379-16.473 52.66-2.664 15.277 13.801 16.473 37.38 2.664 52.656L268.03 381.32c-7.328 8.11-17.469 12.29-27.68 12.29z"
});

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCheck;